import React, { Component } from "react";
import {
  Typography,
  Grid,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Chip,
} from "@material-ui/core";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Button, FormControl, Card } from "react-bootstrap";
import { PostData, GetData, DeleteData, PutData } from "../../api/service";
import Snack from "../Snackbar/Snack";
import FileUpload from "../AddNew/FileUpload";
import Edit from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import history from "../../history";
import { Q_LIST, SERVER_UPLOAD } from "../../Helpers/GlobalVariables";
import FileUploadFaculty from "./FileUploadFaculty";

class StudentRelatedActivity extends Component {
  state = {
    m_type: this.props.m_type,
    employee_id: this.props.employee_id,
    email:this.props.email,
    message: "",
    open: false,
    isLoaded: false,
    year:'',
    quarter:'',
    activity:'',
    student_count:'',
    remark:'',
    student_related_activity:[]
  };

  handleChange = (name, value) => {
    this.setState({
      [name]: value,
    });
  };

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  componentDidMount() {
    //console.log(this.props);

    GetData(`/admin/${this.props.employee_id}/getsingleempolyeedataapi`)
    .then((resp)=>{
        if(resp){
            this.setState({
                ...resp,
          
              
              });
        }
        this.setState({
          isLoaded: true
        })
    })

    
  }

//   componentDidUpdate(prevProps){
//     if(this.props !== prevProps){
//         this.setState({
//             seminar:this.props.seminar
      
//         })
//     }
// }


  onSubmit = (e) => {
    e.preventDefault();

    let d = this.state;

    PostData(`/admin/${this.props.employee_id}/addemployeeapi`, d).then(
      (resp) => {
        //console.log(resp)
        this.setState({
          message: resp,
          open: true,
        });
      }
    );
  };


  onAddClick = () => {
    let d = {
        year:this.state.year,
    quarter: this.state.quarter,
    activity:this.state.activity,
    student_count:this.state.student_count,
    remark:this.state.remark,

    }

    let student_related_activity = this.state.student_related_activity != null ? this.state.student_related_activity : [];
    student_related_activity.push(d);
    this.setState({
        student_related_activity
    }, () => {
            this.setState({
                year:'',
                quarter:'',
                activity:'',
                student_count:'',
                remark:'',
            })
    })
}

onDelete = (index) => {
    let student_related_activity = this.state.student_related_activity;
    student_related_activity.splice(index,1);

    this.setState({
        student_related_activity
    })
}


onChange1 = (name, index, value) => {
  let d = this.state.student_related_activity;
  d[index][name] = value
  this.setState({
    student_related_activity: d
  })
}


onSetFile = (index, data) => {
    //console.log(data)
    let aw = this.state.student_related_activity;
    aw[index]['file'] = data
    this.setState({
        student_related_activity: aw
    })
  }

  render() {
    return (
      <div>
        {this.state.open ? (
          <Snack
            open={this.state.open}
            message={this.state.message}
            handleClose={() => {
              this.setState({
                open: false,
                message: "",
              });
            }}
          />
        ) : null}

{this.state.isLoaded && <form onSubmit={this.onSubmit}>
          <Typography variant="h6" gutterBottom>
            {this.props.title}
          </Typography>
          
           <table width="100%" className="table table-sm">
          <thead>
            <tr>
            <td>Year</td>
            <td>Quarter</td>
            <td>Activity Details with Date</td>
            <td>No of students participated/involved</td>
            <td>Remark (if Any)</td>
            <td></td>
            
            {/* <td>Year</td> */}
    
              
              
              <td>Click + to Add</td>
            </tr>
          </thead>
          <tbody>
            <tr>
            <td>
                <input
                  className="form-control"
                  type="text"
                  name="year"
                  value={this.state.year}
                  onChange={this.onChange}
                  placeholder="Year"
                />
              </td>
              <td>
              <select
                      className="form-control"
                      type="text"
                      name="quarter"
                      value={this.state.quarter}
                      onChange={this.onChange}
                      placeholder="Quarter"
                    >
                      <option>select</option>
                      {Array.isArray(Q_LIST) && Q_LIST.map((el,index) => <option key={index} value={el}>{el}</option>)}
                    </select>
              </td>
              <td>
                <textarea
                  className="form-control"
                  type="text"
                  name="activity"
                  value={this.state.activity}
                  onChange={this.onChange}
                  placeholder="Activity Details with Date"
                />
              </td>

              <td>
                <input
                  className="form-control"
                  type="text"
                  name="student_count"
                  value={this.state.student_count}
                  onChange={this.onChange}
                  placeholder="No of students participated/involved"
                />
              </td>

              <td>
                <input
                  className="form-control"
                  type="text"
                  name="remark"
                  value={this.state.remark}
                  onChange={this.onChange}
                  placeholder="Remark
                  (If Any)"
                />
              </td>
              <td>
                You can upload the file after addition
              </td>
              
              
              
            
              
              

              

             
              
              <td>
                <Button
                  variant="outlined"
                  onClick={this.onAddClick}
                  type="button"
                >
                  +
                </Button>
              </td>
            </tr>
          </tbody>
          <tbody>
            {Array.isArray(this.state.student_related_activity) && this.state.student_related_activity.map((el, index) => (
              <tr key={index}>
                <td>
                <textarea
                      className="form-control"
                      type="text"
                      name="year"
                      value={el.year}
                      onChange={(e) => this.onChange1('year', index, e.target.value)}
                      placeholder="year"
                    /></td>
                    <td><select
                      className="form-control"
                      type="text"
                      name="quarter"
                      value={el.quarter}
                      onChange={(e) => this.onChange1('quarter', index, e.target.value)}
                      placeholder="quarter"
                    ><option>select</option>
                    {Array.isArray(Q_LIST) && Q_LIST.map((el,index) => <option key={index} value={el}>{el}</option>)}
                      </select></td>
                <td> <textarea
                      className="form-control"
                      type="text"
                      name="activity"
                      value={el.activity}
                      onChange={(e) => this.onChange1('activity', index, e.target.value)}
                      placeholder="Activity Details with Date"
                    /></td>
                    <td> <textarea
                      className="form-control"
                      type="text"
                      name="student_count"
                      value={el.student_count}
                      onChange={(e) => this.onChange1('student_count', index, e.target.value)}
                      placeholder="No of students participated/involved"
                    /></td>
                <td><input
                      className="form-control"
                      type="text"
                      name="remark"
                      value={el.remark}
                      onChange={(e) => this.onChange1('remark', index, e.target.value)}
                      placeholder="Remarks"
                    /></td>
                <td style={{whiteSpace: 'nowrap'}}>
                  {Array.isArray(el.file) && el.file.map((el1,index1) => <div key={index1}><a target="_blank" href={`${SERVER_UPLOAD}/${el1.type}/${el1.path}`} style={{fontSize: 10}}>[uploaded] {el1.path}</a></div>)}
                  <FileUploadFaculty files={el.file} onSetFile={(data) => this.onSetFile(index,data)} type={`FACULTY_STUDENT_RELATED_ACTIVITY`} dp={el.file} apikey={`1234`} />
                  </td>
               
                
                
                
                
               
                
                
                <td>
                  <Delete onClick={this.onDelete.bind(this, index)} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
                <br />
        <div align="right">
                <Button size="sm" variant="info" type="submit">
                  Submit
                </Button>
              </div>
        
        </form>}
      </div>
    );
  }
}

export default StudentRelatedActivity;
